import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, Col, Label, Row } from "reactstrap";
import {
  PLAN_FEATURE_KEY_OPTION,
  PLAN_FEATURE_LIMIT_TYPE,
} from "helpers/constans";
import { formatDateString, formatDateStringToKorea } from "helpers/format";

export default function ResumeViewSection({ item }: any) {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    if (item) {
      setData({
        featureKey: item?.featureKey,
        status: item?.isUsable === true ? "Active" : "Disable",
        limitType: item?.isUnlimited === false ? "QUOTA" : "UNLIMITED",
        startDate: item?.startDate,
        endDate: item?.endDate,
        createdAt: item?.createdAt,
      });
    }
  }, [item]);

  return (
    <div>
      <span className="text-white bg-success px-3 py-1 d-inline-block">
        {t(
          PLAN_FEATURE_KEY_OPTION?.find(
            (item: any) => String(item?.value) === String(data?.featureKey)
          )?.label || ""
        )}
      </span>
      <Card style={{ borderTopLeftRadius: 0 }}>
        <CardBody>
          <div className="my-3 d-flex flex-column flex-lg-row gap-4 gap-lg-4">
            <Row className="w-100">
              <Col md={4} lg={4}>
                <div className="mb-3">
                  <Label htmlFor="name" className="form-label">
                    {t("Limit Type")}
                  </Label>
                  <div className="cursor-pointer">
                    {data?.limitType ? (
                      t(
                        PLAN_FEATURE_LIMIT_TYPE?.find(
                          (item: any) => String(item?.value) === String(data?.limitType)
                        )?.label || ""
                      )
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </Col>

              <Col md={4} lg={4}>
                <div className="mb-3">
                  <Label htmlFor="signup_date" className="form-label">
                    {t("Start Date")}
                  </Label>
                  <div>
                    {data?.startDate
                      ? formatDateString(data?.startDate)
                      : "-"}
                  </div>
                </div>
              </Col>

              <Col md={4} lg={4}>
                <div className="mb-3">
                  <Label htmlFor="signup_date" className="form-label">
                    {t("End Date")}
                  </Label>
                  <div>
                    {data?.endDate
                      ? formatDateString(data?.endDate)
                      : "-"}
                  </div>
                </div>
              </Col>

              <Col md={4} lg={4}>
                <div className="mb-3">
                  <Label htmlFor="name" className="form-label">
                    {t("Status")}
                  </Label>
                  <div className="cursor-pointer">
                    {
                      data?.status ? (
                        <span
                          className={`rounded-pill badge bg-${data?.status === "Active" ? "success" : "danger"}`}
                          style={{
                            fontSize: "0.8rem",
                            lineHeight: 1
                          }}
                        >
                          {t(data?.status || "")}
                        </span>
                      ) : "-"
                    }
                  </div>
                </div>
              </Col>

              <Col md={6} lg={6}>
                <div className="mb-3">
                  <Label htmlFor="name" className="form-label">
                    {t("Created at")}
                  </Label>
                  <div>
                    {data?.createdAt
                      ? formatDateStringToKorea(data?.createdAt)
                      : "-"}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
